var ua = window.navigator.userAgent.toLowerCase();

export default {
  isOppoBrowser: function () {
    return /(oppo|nearme|realme|oneplus|heytap)browser/.test(ua);
  },

  getMainVersion: function () {
    var version = this.getFullVersion();
    var main = parseFloat(version);

    if (version && main) {
      return main;
    } else {
      return null;
    }
  },

  getFullVersion: function (isFull) {
    if (!this.isOppoBrowser()) {
      return;
    }
    var result = ua.match(
      /(?:oppo|nearme|realme|oneplus|heytap)browser\/([\w\-.]+\b)/,
    );
    return result && result[1];
  },
};
